import $ from 'jquery'
import 'bootstrap/js/tooltip'
import 'bootstrap/js/popover'

export default {
  install (Vue) {
    Vue.directive('popover', {
      bind () {
        $(this.el).popover()
      },
      unbind () {
        $(this.el).popover('destroy')
      }
    })
  }
}



/** WEBPACK FOOTER **
 ** ./src/directives/v-popover.js
 **/